import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./Footer.css";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt, FaArrowUp } from "react-icons/fa";
import footerContentImage from "../assets/Home/Footer img.jpg";
import vardaanVLogo from "../assets/Home/Vardaan V icon.png";

const FOOTER_BG_IMAGE = footerContentImage;

const Footer = () => {
  const history = useHistory();
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <footer className="footer">
      <div
        className="footer-video-container footer-bg-image"
      >
        <img
          src={FOOTER_BG_IMAGE}
          alt=""
          className="footer-background-image"
          aria-hidden="true"
        />
      </div>
      
      <div
        className="footer-content"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.62), rgba(255, 255, 255, 0.62)), url(${footerContentImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="footer-section company-info">
          <div className="footer-logo">
            <img src={vardaanVLogo} alt="Vardaan Global Logo" />
            <span className="footer-brand-text">Vardaan Global</span>
          </div>
          <div className="contact">
            <div className="contact-item"><FaEnvelope className="contact-icon" /> <span>info@vardaanglobal.com</span></div>
            <div className="contact-item"><FaMapMarkerAlt className="contact-icon" /> <span>Vardaan Global INC, 70 Bluebird Ln Ste G, Plainview, NY, 11803, USA</span></div>
          </div>
          <div className="socials">
            <a href="https://www.facebook.com/profile.php?id=61554735873727" target="_blank" rel="noopener noreferrer"><FaFacebook className="social-icon" /></a>
            <a href="https://www.linkedin.com/company/vardaan-data-sciences-pvt-ltd/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><FaLinkedin className="social-icon" /></a>
            <a href="https://www.instagram.com/vardaan_datasciences?igsh=MXYzN2YwcTExMjVnNg==" target="_blank" rel="noopener noreferrer"><FaInstagram className="social-icon" /></a>
          </div>
        </div>
        
        <div className="footer-links-container">
          <div className="footer-links-row">
            <div className="footer-section links">
              <h2>QUICK LINKS</h2>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/products">Our Products</a></li>
                <li><a href="/services">Our Service Offerings</a></li>
                <li><a href="/about">About Vardaan</a></li>
                <li><a href="/contact">Contact Us</a></li>
              </ul>
            </div>
          
            <div className="footer-section reach-out-with-info">
              <div className="reach-out-content">
                <h2>Do you want to reach out to us?</h2>
                <button 
                  onClick={() => {
                    // Navigate to contact page with hash
                    history.push('/contact#vg-mobile-form');
                    // The Contact Us page's useEffect will handle the scroll
                    // This is just a backup in case the useEffect doesn't catch it
                    const scrollToForm = () => {
                      const formElement = document.getElementById('vg-mobile-form') || 
                                         document.querySelector('.vg-mobile-form') || 
                                         document.querySelector('.vg-contact-form-section');
                      if (formElement) {
                        const navbarOffset = 100;
                        const elementTop = formElement.offsetTop || formElement.getBoundingClientRect().top + window.pageYOffset;
                        const offsetPosition = elementTop - navbarOffset;
                        window.scrollTo({
                          top: Math.max(0, offsetPosition),
                          behavior: 'smooth'
                        });
                        return true;
                      }
                      return false;
                    };
                    
                    // Try multiple times with delays (backup scroll)
                    const attempts = [800, 1500, 2500, 4000];
                    attempts.forEach(delay => {
                      setTimeout(() => {
                        if (window.location.pathname === '/contact') {
                          scrollToForm();
                        }
                      }, delay);
                    });
                  }}
                  className="contact-us-button"
                  type="button"
                >
                  <FaEnvelope className="contact-us-icon" />
                  <span>Contact Us</span>
                </button>
              </div>
              
              <div className="information-content">
                <h2>INFORMATION</h2>
                <ul>
                  <li><a href="/privacy-policy">Privacy Policy</a></li>
                  <li><a href="/cookie-policy">Cookie Policy & Consent Management</a></li>
                  <li><a href="/terms-of-service">Terms of Service / Use</a></li>
                  <li><a href="/data-retention-policy">Data Retention & Deletion Policy</a></li>
                  <li><a href="/international-data-transfers">International Data Transfers Notice</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Vardaan Global. All Rights Reserved.</p>
      </div>
      
      {showBackToTop && (
        <div className="back-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </div>
      )}
    </footer>
  );
};

export default Footer; 